"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCopytoClipboard = void 0;

var React = __importStar(require("react"));

var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));

function useCopytoClipboard(text, timeout) {
  if (timeout === void 0) {
    timeout = 1500;
  }

  var _a = React.useState(false),
      hasCopied = _a[0],
      setHasCopied = _a[1];

  var onCopy = React.useCallback(function () {
    var didCopy = copy_to_clipboard_1.default(text);
    setHasCopied(didCopy);
  }, [text]);
  React.useEffect(function () {
    if (hasCopied) {
      var id_1 = setTimeout(function () {
        setHasCopied(false);
      }, timeout);
      return function cleanup() {
        clearTimeout(id_1);
      };
    }
  }, [timeout, hasCopied]);
  return {
    value: text,
    hasCopied: hasCopied,
    onCopy: onCopy
  };
}

exports.useCopytoClipboard = useCopytoClipboard;